import React, { useState } from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Checkbox } from '@progress/kendo-react-inputs';
import { updateNode } from '../Helpers/Nodes';

export const SuccessfulPublishContent = (props) => {

    const {
        user, updateUserState,
        onClose, workspaceUrl,
        isShowFromWorkspace, onBack,
        message = "App is successfully generated",
        showButtons = true
    } = props

    const [dontShowSuccessDialog, setDontShowSuccessDialog] = useState(false);

    const handleClose = () => {
        if (dontShowSuccessDialog) {
            updateNode("User", user.id, { showSuccessDialog: "false" });
            if (updateUserState) {
                updateUserState({
                    ...user,
                    showSuccessDialog: "false"
                })
            }
        }
        onClose();
    }
    return (
        <div className="d-flex flex-column justify-content-center align-items-center h-100 w-100">
            <div className="col-12 text-center">
                <img
                    alt='app-success'
                    height={"200rem"}
                    src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/successful_publish.png`} />
            </div>
            <div className="row">
                <div className="col-12 text-center py-3">
                    <h3>{message}</h3>
                </div>
                {showButtons &&
                    <div className="col-12 text-center py-2">
                        {
                            isShowFromWorkspace ?
                                <button
                                    onClick={onBack}
                                    className='btn btn-primary rounded-pill font-size-2 me-2'>
                                    Install more App
                                </button>
                                :
                                <button
                                    className='btn btn-primary rounded-pill font-size-2'
                                    onClick={handleClose}>
                                    Okay
                                </button>
                        }
                    </div>
                }
                {
                    !isShowFromWorkspace &&
                    <div className="col-12 text-center py-2">
                        <Checkbox
                            className='font-size-3 dont-show-check'
                            label="Don't show this popup again"
                            onChange={(e) => setDontShowSuccessDialog(e.value)}
                            checked={dontShowSuccessDialog} />
                    </div>
                }
            </div>
        </div>
    )
}


const SuccessfulPublishDialog = (props) => {

    return (
        <Dialog
            title=" "
            onClose={props.onClose}
            width="30%">
            <SuccessfulPublishContent {...props} />
        </Dialog>
    )
}

export default SuccessfulPublishDialog;